// extracted by mini-css-extract-plugin
export var auto = "_3q-1";
export var spinner = "_3q-0";